/*
 * amaflow: Eigene Groessenempfehlung im Popup der MP Size Chart App
 *
 * Die App gibt immer genau EINE Groesse aus, und zwar die kleinste passende.
 * Max & Molly braucht etwas anderes: einen Zuschlag auf den gemessenen Umfang,
 * bis zu zwei Vorschlaege und je Vorschlag eine Zusatzangabe, an der sich der
 * Kunde entscheidet (Bandbreite, Taudurchmesser, Rueckenlaenge ...).
 *
 * Eingabefelder, Groessentabelle und Gestaltung bleiben die der App. Ersetzt
 * wird nur der Ergebnisbereich rechts.
 *
 * Datenquelle ist window.AVADA_SC - dort liegen alle Tabellen samt Zeilen und
 * die Zuordnung, welches Eingabefeld auf welche Tabellenspalte zeigt.
 *
 * Sprachen: Die App haelt ihre Konfiguration auch auf englischen Seiten auf
 * Deutsch und uebersetzt erst das gerenderte DOM. Fremde Inhalte fasst sie
 * dabei nicht an - geprueft. Unsere Texte muessen deshalb selbst zweisprachig
 * sein, und die Tabellenerkennung darf sich nicht auf Spaltennamen stuetzen.
 *
 * Grundsatz: Wenn irgendetwas nicht eindeutig ist (Tabelle nicht erkannt,
 * keine Regel hinterlegt, Spalte fehlt), wird NICHT eingegriffen. Dann bleibt
 * die Ausgabe der App stehen. Lieber die alte Empfehlung als eine falsche.
 */
(function () {
  /* amaflow: Notschalter zum Eingrenzen von Fehlern.
       ?mm-off=1        schaltet beide eigenen Skripte ab
       ?mm-off=advisor  schaltet nur diesen Umbau ab
     Ohne den Parameter aendert sich nichts. */
  if (/[?&]mm-off=(1|alle|advisor)/.test(window.location.search)) return;

  'use strict';
  if (window.__mmSizeAdvisor) return;
  window.__mmSizeAdvisor = true;

  var SPRACHE = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase() === 'en' ? 'en' : 'de';

  /* Nimmt entweder einen String oder ein {de,en}-Paar. */
  function t(wert) {
    if (wert && typeof wert === 'object' && !Array.isArray(wert)) {
      return wert[SPRACHE] || wert.de || '';
    }
    return wert || '';
  }

  var TEXTE = {
    mehrere: {
      de: 'Basierend auf deinen Angaben kommen zwei Größen für deine Fellnase infrage.',
      en: 'Based on your measurements, two sizes could suit your furry friend.'
    },
    eine: {
      de: 'Basierend auf deinen Angaben empfehlen wir die Größe:',
      en: 'Based on your measurements, we recommend size:'
    },
    keine: {
      de: 'Wir können keine passende Größe finden.',
      en: 'We could not find a matching size.'
    },
    tipp: {
      de: 'Tippe eine Größe an, um sie zu übernehmen.',
      en: 'Tap a size to apply it.'
    }
  };

  /* Bezeichnungen der abgefragten Masse - werden gebraucht, wenn fuer eine
     Tabelle keine Zusatzspalte hinterlegt ist und ersatzweise die Bereiche der
     abgefragten Werte erscheinen. Die Spaltennamen in der App sind deutsch. */
  var MASS_LABEL = {
    brust: { de: 'Brust', en: 'Chest' },
    hals: { de: 'Hals', en: 'Neck' },
    halsumfang: { de: 'Halsumfang', en: 'Neck girth' },
    taille: { de: 'Taille', en: 'Waist' },
    taillenumfang: { de: 'Taillenumfang', en: 'Waist' },
    rückenlänge: { de: 'Rückenlänge', en: 'Back length' },
    länge: { de: 'Länge', en: 'Length' },
    breite: { de: 'Breite', en: 'Width' }
  };

  /* ------------------------------------------------------------------
   * Regelwerk je Groessentabelle
   *
   * Schluessel = Name der Tabelle in der MP Size Chart App.
   * Kommt eine Tabelle hier nicht vor, bleibt die App-Ausgabe unberuehrt.
   *
   *   zugabe        Aufschlag in cm je Eingabefeld (Spaltenname der Tabelle).
   *                 Nur auf Umfaenge, nicht auf Laengen.
   *   nurMessen     Schraenkt die Pruefung auf diese Spalten ein. Alle uebrigen
   *                 Eingaben dienen nur dem Hinweis.
   *   obergrenze    Spalten, deren Tabellenwert eine Obergrenze ist statt einer
   *                 Spanne ("Rueckenlaenge 40" heisst "bis 40 cm").
   *   immerZwei     Auch bei nur einem Treffer die naechstgroessere ergaenzen.
   *   extra         Zusatzangaben je Vorschlag, aus diesen Tabellenspalten.
   *   einleitung    Text ueber den beiden Vorschlaegen.
   *   hinweis       Zusatz darunter, bei Abweichung oder Ergaenzung.
   * ------------------------------------------------------------------ */
  var BANDBREITE = { de: 'Bandbreite', en: 'Strap width' };
  var GURTBREITE = { de: 'Gurtbreite', en: 'Strap width' };
  var RUECKENLAENGE = { de: 'Rückenlänge', en: 'Back length' };
  var HALSBAND_TEXT = { de: 'Wähle die gewünschte Bandbreite:', en: 'Choose your preferred strap width:' };

  var REGELN = {
    'DE Size Chart Dog Collar Original Gear': {
      zugabe: { 'Hals (cm)': 2 },
      extra: [{ spalte: 'Gurtbreite (cm)', label: BANDBREITE, einheit: 'cm' }],
      einleitung: HALSBAND_TEXT
    },
    'DE Size Chart Dog Collar Matrix 2.0': {
      zugabe: { 'Halsumfang (cm)': 2 },
      extra: [{ spalte: 'Gurtbreite (cm)', label: BANDBREITE, einheit: 'cm' }],
      einleitung: HALSBAND_TEXT
    },
    'DE Size Chart Martingale Dog Collar Matrix 2': {
      zugabe: { 'Halsumfang (cm)': 2 },
      extra: [{ spalte: 'Durchmesser (cm)', label: { de: 'Taudurchmesser', en: 'Rope diameter' }, einheit: 'cm' }],
      einleitung: { de: 'Wähle den gewünschten Taudurchmesser:', en: 'Choose your preferred rope diameter:' },
      /* Michaela: Das Zugstopphalsband ist sehr variabel einstellbar, deshalb
         sollen immer zwei Groessen zur Wahl stehen. */
      immerZwei: true,
      hinweis: {
        de: 'Das Zugstopphalsband ist variabel einstellbar. Bei der größeren Größe wird das Tau dicker.',
        en: 'The martingale collar is highly adjustable. The larger size has a thicker rope.'
      }
    },
    'DE Size Chart Dog Wide Collar Matrix 2.0': {
      zugabe: { 'Halsumfang (cm)': 2 }
    },
    'DE Size Chart Matrix 2.0 Sport Harness': {
      zugabe: { 'Brust (cm)': 2, 'Hals (cm)': 2 },
      extra: [
        { spalte: 'Rückensteg (cm)', label: RUECKENLAENGE, einheit: 'cm' },
        { spalte: 'Bauchsteg (cm)', label: { de: 'Bauchsteglänge', en: 'Belly strap length' }, einheit: 'cm' }
      ],
      einleitung: {
        de: 'Entscheide anhand der passenden Rücken- und Bauchsteglänge:',
        en: 'Decide based on the back and belly strap length:'
      }
    },
    'DE Size Chart Comfort H-Harness Matrix 2.0': {
      zugabe: { 'Brust(cm)': 2, 'Hals (cm)': 2 },
      extra: [
        { spalte: 'Steglänge (cm)', label: { de: 'Steglänge', en: 'Strap length' }, einheit: 'cm' },
        { spalte: 'Gurtbreite (cm)', label: GURTBREITE, einheit: 'cm' }
      ],
      einleitung: {
        de: 'Entscheide anhand der passenden Steglänge und Gurtbreite:',
        en: 'Decide based on the strap length and strap width:'
      }
    },
    'DE Size Chart H-Harness Original Gear': {
      zugabe: { 'Brust (cm)': 2, 'Hals (cm)': 2 },
      extra: [
        { spalte: 'Rückenlänge (cm)', label: RUECKENLAENGE, einheit: 'cm' },
        { spalte: 'Breite (cm)', label: GURTBREITE, einheit: 'cm' }
      ],
      einleitung: {
        de: 'Entscheide anhand der passenden Rückenlänge und Gurtbreite:',
        en: 'Decide based on the back length and strap width:'
      }
    },
    'DE Size Chart Air Vest': {
      /* Michaela: vorrangig nach Brustumfang, Hals nur als Hinweis. */
      zugabe: { 'Brust (cm)': 2, 'Hals cm)': 2 },
      nurMessen: ['Brust (cm)'],
      einleitung: {
        de: 'Wir empfehlen dir, die größere Größe zu wählen.',
        en: 'We recommend choosing the larger size.'
      },
      hinweis: {
        de: 'Der Halsumfang deines Hundes liegt außerhalb des Bereichs dieser Größe – bitte vergleiche ihn in der Größentabelle.',
        en: 'Your dog’s neck girth is outside the range for this size – please compare it in the size chart.'
      }
    },
    'DE Sizing Chart Q-Fit Harness': {
      zugabe: { 'Brust (cm)': 2 },
      einleitung: {
        de: 'Bei Überschneidungen empfehlen wir dir die größere Größe.',
        en: 'Where sizes overlap, we recommend the larger one.'
      }
    },
    /* Inhaltlich identische Dublette der Tabelle darueber - in der App sind
       beide angelegt. Welche die App zieht, ist von aussen nicht erkennbar. */
    'DE Sizing Chart Q-Fit Harness Classic Matrix': {
      zugabe: { 'Brust (cm)': 2 },
      einleitung: {
        de: 'Bei Überschneidungen empfehlen wir dir die größere Größe.',
        en: 'Where sizes overlap, we recommend the larger one.'
      }
    },
    'DE Size Chart Raincoat for dogs': {
      /* Bewusst kein Zuschlag: Michaela nennt die 2 cm nur bei Halsbaendern
         und Geschirren, nicht beim Regenmantel. Mit Zuschlag ergaebe ihr
         Beispiel (Bauchumfang 55) S und M statt der erwarteten XXS und XS.
         Rueckenlaenge und Hals sind feste Einzelwerte; als harte Bedingung
         wuerden sie fast jede Kombination ausschliessen. Deshalb entscheidet
         der Bauchumfang, der Rest dient dem Vergleich. */
      nurMessen: ['Brust (cm)'],
      obergrenze: ['Rückenlänge (cm)', 'Hals (cm)'],
      extra: [
        { spalte: 'Rückenlänge (cm)', label: RUECKENLAENGE, einheit: 'cm' },
        { spalte: 'Brust (cm)', label: { de: 'Bauchumfang', en: 'Girth' }, einheit: 'cm' },
        { spalte: 'Hals (cm)', label: { de: 'Halsumfang', en: 'Neck girth' }, einheit: 'cm' }
      ],
      einleitung: {
        de: 'Vergleiche die angegebenen Maße. Bei Überschneidungen empfehlen wir dir die größere Größe.',
        en: 'Compare the measurements shown. Where sizes overlap, we recommend the larger one.'
      },
      hinweis: {
        de: 'Bitte vergleiche zusätzlich Rückenlänge und Halsumfang mit den Angaben oben.',
        en: 'Please also compare the back length and neck girth with the values shown.'
      }
    }
  };

  /* --- Hilfen ----------------------------------------------------- */

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[\s()]/g, '');
  }

  /* Zellwerte zahlentolerant vergleichen: Die App rendert "2", in der
     Konfiguration steht "2.0" - formal ungleich, inhaltlich gleich. */
  function normZahl(s) {
    return norm(s).replace(/,/g, '.').replace(/(\d)\.0+(?!\d)/g, '$1');
  }

  /* "22 - 35" -> {min:22,max:35} | "40" -> {min:40,max:40} | sonst null */
  function spanne(text) {
    if (text == null) return null;
    var x = String(text).replace(/,/g, '.');
    var m = x.match(/(-?\d+(?:\.\d+)?)\s*[-–]\s*(-?\d+(?:\.\d+)?)/);
    if (m) return { min: parseFloat(m[1]), max: parseFloat(m[2]) };
    var e = x.match(/(-?\d+(?:\.\d+)?)/);
    if (e) return { min: parseFloat(e[1]), max: parseFloat(e[1]) };
    return null;
  }

  /* Dezimaltrenner nach Seitensprache: 1,5 cm auf Deutsch, 1.5 cm auf
     Englisch. In der Konfiguration steht mal das eine, mal das andere. */
  function zahl(wert) {
    var x = String(wert).trim();
    return SPRACHE === 'en' ? x.replace(/,/g, '.') : x.replace(/\./g, ',');
  }

  function spalteNach(td, name) {
    var ziel = norm(name);
    for (var i = 0; i < td.columns.length; i++) {
      if (norm(td.columns[i].name) === ziel) return td.columns[i];
    }
    return null;
  }

  /* Deutschen Spaltennamen in die Seitensprache uebersetzen. */
  function massLabel(name) {
    var k = norm(name).replace(/cm\)?$/, '').replace(/\(+$/, '');
    return MASS_LABEL[k] ? t(MASS_LABEL[k]) : String(name).replace(/\s*\(?cm\)?\s*$/i, '').trim();
  }

  /* --- Aktive Tabelle bestimmen ------------------------------------
   * Die App entscheidet selbst, welche Tabelle sie zeigt, und ihre Bedingungen
   * geben das nicht her (mehrere Tabellen haben gar keine). Deshalb wird die
   * gerenderte Tabelle mit denen aus AVADA_SC verglichen.
   *
   * Verglichen wird ueber Groessenkuerzel und Zahlenwerte - beides uebersetzt
   * die App nicht (sie schliesst Kuerzel sogar ausdruecklich aus). Die
   * Spaltennamen taugen nicht: Auf englischen Seiten sind sie uebersetzt,
   * in der Konfiguration stehen sie deutsch.
   */
  function aktiveTabelle(wurzel) {
    var sc = window.AVADA_SC;
    if (!sc || !sc.campaignsList) return null;
    var tab = wurzel.querySelector('table');
    if (!tab) return null;

    var zeilen = [].slice.call(tab.querySelectorAll('tr'));
    if (zeilen.length < 2) return null;

    var kopfNamen = [].slice.call(zeilen[0].children).map(function (z) { return norm(z.textContent); }).join('|');
    var groessen = zeilen.slice(1).map(function (tr) {
      return norm(tr.children[0] && tr.children[0].textContent);
    }).join('|');
    var zellen = zeilen.slice(1).map(function (tr) {
      return [].slice.call(tr.children).map(function (td) { return normZahl(td.textContent); }).join('~');
    }).join('|');

    var kandidaten = [];
    for (var i = 0; i < sc.campaignsList.length; i++) {
      var c = sc.campaignsList[i];
      var block = null;
      for (var j = 0; j < (c.contentConfigs || []).length; j++) {
        if (c.contentConfigs[j].tableData) { block = c.contentConfigs[j]; break; }
      }
      if (!block) continue;
      var td = block.tableData;
      var k = td.columns.map(function (s) { return norm(s.name); }).join('|');
      var g = td.rows.map(function (r) { return norm(r[td.columns[0].id]); }).join('|');
      var z = td.rows.map(function (r) {
        return td.columns.map(function (s) { return normZahl(r[s.id]); }).join('~');
      }).join('|');
      if (g !== groessen) continue;
      if (z !== zellen && k !== kopfNamen) continue;
      kandidaten.push({ kampagne: c, tabelle: td, zellenGleich: z === zellen });
    }
    if (!kandidaten.length) return null;

    /* Rangfolge: gleiche Zahlenwerte und Regel, dann Regel, dann erster. */
    var a = kandidaten.filter(function (x) { return x.zellenGleich && REGELN[x.kampagne.name]; })[0];
    var b = kandidaten.filter(function (x) { return REGELN[x.kampagne.name]; })[0];
    return a || b || kandidaten[0];
  }

  /* --- Eingaben lesen ---------------------------------------------- */
  function eingaben(wurzel, kampagne) {
    var felder = [].slice.call(wurzel.querySelectorAll('.SRContent__InputWrapper input'));
    var auswahl = ((kampagne.sizeRecommend || {}).measurement || {}).select || [];
    if (!felder.length || felder.length !== auswahl.length) return null;
    var out = [];
    for (var i = 0; i < felder.length; i++) {
      var v = parseFloat(String(felder[i].value).replace(',', '.'));
      if (isNaN(v)) return null;
      out.push({ spalteId: auswahl[i].contentId, name: auswahl[i].name, wert: v });
    }
    return out;
  }

  /* --- Passende Groessen ermitteln ---------------------------------- */
  function ermitteln(td, werte, regel) {
    var nurMessen = regel.nurMessen ? regel.nurMessen.map(norm) : null;
    var obergrenze = (regel.obergrenze || []).map(norm);

    var treffer = td.rows.filter(function (zeile) {
      return werte.every(function (w) {
        if (nurMessen && nurMessen.indexOf(norm(w.name)) === -1) return true;
        var s = spanne(zeile[w.spalteId]);
        if (!s) return false;
        var v = w.wert + ((regel.zugabe || {})[w.name] || 0);
        if (obergrenze.indexOf(norm(w.name)) !== -1) return v <= s.max;
        return v >= s.min && v <= s.max;
      });
    });

    /* Michaela: sind mehr als zwei Groessen moeglich, die groesseren anbieten. */
    if (treffer.length > 2) treffer = treffer.slice(-2);

    /* Tabellen mit immerZwei: passt nur eine, naechstgroessere ergaenzen. */
    var ergaenzt = false;
    if (regel.immerZwei && treffer.length === 1) {
      var pos = td.rows.indexOf(treffer[0]);
      if (pos > -1 && td.rows[pos + 1]) {
        treffer = [treffer[0], td.rows[pos + 1]];
        ergaenzt = true;
      }
    }

    /* Masse, die laut Regel nicht ueber die Groesse entscheiden (beim Air Vest
       der Hals), nur pruefen, um darauf hinzuweisen, wenn sie nicht hinkommen. */
    var abweichung = false;
    if (nurMessen && treffer.length) {
      abweichung = werte.some(function (w) {
        if (nurMessen.indexOf(norm(w.name)) !== -1) return false;
        var v = w.wert + ((regel.zugabe || {})[w.name] || 0);
        return treffer.some(function (zeile) {
          var s = spanne(zeile[w.spalteId]);
          return !s || v < s.min || v > s.max;
        });
      });
    }

    return { zeilen: treffer, abweichung: abweichung, ergaenzt: ergaenzt, werte: werte };
  }

  /* --- Ausgabe ------------------------------------------------------ */

  /* Angaben als Label/Wert-Paare. Ohne hinterlegte Zusatzspalte ersatzweise
     die Bereiche der abgefragten Masse - sonst stuende dort nur die Groesse. */
  function zusatz(td, zeile, regel, werte) {
    var paare = (regel.extra || []).map(function (e) {
      var sp = spalteNach(td, e.spalte);
      if (!sp) return null;
      var w = zeile[sp.id];
      if (w == null || String(w).trim() === '') return null;
      return {
        k: t(e.label) || sp.name,
        v: zahl(w) + (e.einheit ? ' ' + e.einheit : '')
      };
    }).filter(Boolean);

    if (paare.length) return paare;

    return (werte || []).map(function (w) {
      var roh = zeile[w.spalteId];
      if (roh == null || String(roh).trim() === '') return null;
      return { k: massLabel(w.name), v: zahl(roh) + ' cm' };
    }).filter(Boolean);
  }

  function zeichnen(spalteRechts, td, ergebnis, regel) {
    var treffer = ergebnis.zeilen;
    var schluessel = td.columns[0].id;
    var box = document.createElement('div');
    box.className = 'mm-adv';

    if (!treffer.length) {
      box.innerHTML = '<p class="mm-adv__intro">' + t(TEXTE.keine) + '</p>';
      spalteRechts.innerHTML = '';
      spalteRechts.appendChild(box);
      return;
    }

    var mehrere = treffer.length > 1;
    var einleitung = mehrere
      ? t(TEXTE.mehrere) + (regel.einleitung ? ' ' + t(regel.einleitung) : '')
      : t(TEXTE.eine);

    var liste = treffer.map(function (z) {
      var detail = zusatz(td, z, regel, ergebnis.werte).map(function (pz) {
        return '<span class="mm-adv__row">' +
          '<span class="mm-adv__k">' + pz.k + '</span>' +
          '<span class="mm-adv__v">' + pz.v + '</span>' +
          '</span>';
      }).join('');
      return '<li class="mm-adv__item">' +
        '<button type="button" class="mm-adv__btn" data-mm-groesse="' + z[schluessel] + '">' +
          '<span class="mm-adv__size">' + z[schluessel] + '</span>' +
          '<span class="mm-adv__detail">' + detail + '</span>' +
          '<span class="mm-adv__pick" aria-hidden="true"></span>' +
        '</button>' +
        '</li>';
    }).join('');

    /* Die groesste der Vorschlaege gilt als "unsere Empfehlung" - versteckt in
       der Original-Klasse, damit mp-size-recommendation.js weiterarbeitet. */
    var empfohlen = treffer[treffer.length - 1][schluessel];
    var zeigeHinweis = regel.hinweis && (ergebnis.abweichung || ergebnis.ergaenzt);

    box.innerHTML =
      '<p class="mm-adv__intro">' + einleitung + '</p>' +
      '<ul class="mm-adv__list">' + liste + '</ul>' +
      (zeigeHinweis ? '<p class="mm-adv__hint">' + t(regel.hinweis) + '</p>' : '') +
      '<p class="mm-adv__tip">' + t(TEXTE.tipp) + '</p>' +
      '<div class="SRContent__Column--size mm-adv__echo" aria-hidden="true">' + empfohlen + '</div>';

    spalteRechts.innerHTML = '';
    spalteRechts.appendChild(box);

    [].slice.call(box.querySelectorAll('[data-mm-groesse]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        uebernehmen(btn.getAttribute('data-mm-groesse'), box);
      });
    });
  }

  /* --- Auswahl uebernehmen -------------------------------------------
   * Klick auf einen Vorschlag waehlt die Groesse am Produkt und schliesst das
   * Popup. Der versteckte Wert fuer mp-size-recommendation.js wird vorher
   * mitgezogen, sonst wuerde dessen gespeicherte Empfehlung die Auswahl des
   * Kunden gleich wieder ueberschreiben.
   */
  function uebernehmen(groesse, box) {
    var echo = box.querySelector('.mm-adv__echo');
    if (echo) echo.textContent = groesse;

    var feld = document.querySelector('[data-mm-size-option]');
    if (feld) {
      var ziel = norm(groesse);
      var treffer = [].slice.call(feld.querySelectorAll('input[type="radio"]')).filter(function (i) {
        return norm(i.value) === ziel;
      })[0];
      if (treffer && !treffer.checked) treffer.click();
    }

    var zu = document.querySelector('.Avada-Modal__Close');
    if (zu) zu.click();
  }

  /* --- Einhaengen ---------------------------------------------------- */
  function pruefen(wurzel) {
    var rechts = wurzel.querySelector('.SRContent-ManualLayout__Column.right');
    if (!rechts) return;

    /* Ausgeloest wird nur durch ein frisches Ergebnis der App. Unser eigener
       versteckter Wert traegt dieselbe Klasse und muss ausgenommen werden,
       sonst stiesse sich das Ersetzen endlos selbst an.

       Bewusst keine Sperre "schon ersetzt": Bei einer zweiten Berechnung
       rendert die App ihr Ergebnis erneut in dieselbe Spalte. Wer dann
       abbricht, bekommt beide Ausgaben untereinander. */
    if (!rechts.querySelector('.SRContent__Column--size:not(.mm-adv__echo)')) return;

    var gefunden = aktiveTabelle(wurzel);
    if (!gefunden) return;
    var regel = REGELN[gefunden.kampagne.name];
    if (!regel) return;

    var werte = eingaben(wurzel, gefunden.kampagne);
    if (!werte) return;

    try {
      zeichnen(rechts, gefunden.tabelle, ermitteln(gefunden.tabelle, werte, regel), regel);
    } catch (e) {
      /* Im Zweifel die App-Ausgabe stehen lassen. */
    }
  }

  /* amaflow: Gebuendelt statt bei jeder einzelnen DOM-Aenderung. Beim Oeffnen
     des Fensters feuert die App viele Mutationen kurz hintereinander; ohne
     Bremse laeuft die Tabellenerkennung dutzendfach umsonst. */
  var zeichenTimer = null;
  var beobachter = new MutationObserver(function () {
    window.clearTimeout(zeichenTimer);
    zeichenTimer = window.setTimeout(function () {
      zeichenTimer = null;
      [].slice.call(document.querySelectorAll('.MP-TabWrapper__SR, .Avada-Modal__Container')).forEach(pruefen);
    }, 80);
  });

  function start() {
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
